<template>
	<div class="statistics" id="pageAll">
		<div class="layout-div">
			<div class="layout-top boxBlock">
				<el-row>
					<el-col :span="18" class="rowH"><time-of-public @changeTime="changeTime" :selDays="selDays" ref="timeOfPublic"></time-of-public></el-col>
					<el-col :span="6" class="textR">
						<el-button plain class="borderColor textColor daochubtn" size="mini" @click.stop="exportStatistics">
							<!-- <img src="~@/assets/img/monitoring/fenxibaogao/btn-baocun.png" alt="" /> -->
							<i class="iconfont iconbaocun" style="font-size: 20px;margin-right: 2px;"></i>
							导出报告
						</el-button>
					</el-col>
				</el-row>
				<div class="line"></div>
				<el-row>
					<el-col><filter-status-theme :themName="'专题选择'" @changeVal="changeVal" :themeList="themeList" ref="themeList"></filter-status-theme></el-col>
				</el-row>
			</div>
			<div class="layout-spread boxBlock">
				<div>
					<el-row class="blockTitle">
						<el-col :span="12" class="textColor"><span @click="domForImage('pageAll', '图片')">舆情走势</span></el-col>
						<el-col :span="12" class="textR actionCol">
							<span class="curpointer" @click="domForImage('treedChartsAll', '舆情走势')">
								<!-- <img src="~@/assets/img/monitoring/fenxibaogao/daochu.png" alt="" /> -->
								<i class="iconfont iconbaocun hovertext" style="font-size: 20px;color:#768594;"></i>
								</span>
								
						</el-col>
					</el-row>
				</div>
				<div id="treedChartsAll" style="background-color: #ffffff;">
					<div class="line">
						<div class="titleLine titleLineBk"></div>
						<div class="titledot titleLineBk"></div>
						<div class="titledot titledot2 titleLineBk"></div>
						<div class="titledot titledot3 titleLineBk"></div>
					</div>
					<div class="content">
						<div class="treed" >
							<div class="introduce">
								<div class="infos textOverOneLine" v-html="yuqingMsg">{{ yuqingMsg }}</div>
							</div>
							<div class="checkrow" v-show="yuqingLength > 0">
								<el-checkbox-group v-model="checkList" @change="handleCheckChange">
									<el-checkbox label="all" class="all">全部</el-checkbox>
									<el-checkbox label="weibo" class="weibo">微博</el-checkbox>
									<el-checkbox label="weixin" class="weinxin">微信</el-checkbox>
									<el-checkbox label="other" class="other">其他</el-checkbox>
								</el-checkbox-group>
							</div>
							<div class="treedRow" v-show="yuqingLength > 0"><div id="treedCharts"></div></div>
							<div class="nodata" v-if="yuqingLength === 0">
								<div class="nodataImg">
									<div class="textC ">
										<i class="iconfont iconwushuju wushuju-icon"></i>
										<!-- <img src="~@/assets/img/earlyWarning/wsj_07.png" alt="" /> --></div>
									<div class="textC font14 nodataText">暂无数据！</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="layout-source boxBlock" id="meitiChartsAll" style="background-color: #ffffff;">
				<div>
					<el-row class="blockTitle">
						<el-col :span="12" class="textColor">来源分析</el-col>
						<el-col :span="12" class="textR actionCol">
							<span class="curpointer" @click="domForImage('meitiChartsAll', '来源分析')">
								<!-- <img src="~@/assets/img/monitoring/fenxibaogao/daochu.png" alt="" /> -->
								<i class="iconfont iconbaocun hovertext" style="font-size: 20px;color:#768594;"></i>
								</span>
						</el-col>
					</el-row>
				</div>
				<div class="line">
					<div class="titleLine titleLineBk"></div>
					<div class="titledot titleLineBk"></div>
					<div class="titledot titledot2 titleLineBk"></div>
					<div class="titledot titledot3 titleLineBk"></div>
				</div>
				<div class="content">
					<div class="meiti">
						<div class="introduce">
							<div class="infos textOverTwoLine">{{ sourceTypeMsg }}</div>
						</div>
						<div class="meitiRow">
							<el-row type="flex" justify="space-between">
								<el-col :span="2" class="labels">
									<ul class="labelul">
										<li class="textR" v-for="item in meitisDatas" :key="item.id">
											{{ item.key }}
											<span class="dot" :style="{ backgroundColor: item.color }"></span>
										</li>
									</ul>
								</el-col>
								<el-col :span="12"><div id="meitiCharts" class="meitiCharts"></div></el-col>
								<el-col :span="10" class="tableCol">
									<el-row class="toggle-div">
										<el-col :span="8" :class="{ active: activeMigan === '1' }" name="1"><div @click.stop="toggleMigan('1')">全部</div></el-col>
										<el-col :span="8" name="2" :class="{ active: activeMigan === '2' }"><div @click.stop="toggleMigan('2')">敏感</div></el-col>
										<el-col :span="8" name="3" :class="{ active: activeMigan === '3' }"><div @click.stop="toggleMigan('3')">非敏感</div></el-col>
									</el-row>
									<el-row class="table-div">
										<el-table
											:data="meitisDatas"
											max-height="404"
											style="width: 100%"
											stripe
											border
											:header-cell-style="{ background: '#e7ecf2', color: '#0092f1' }"
										>
											<el-table-column prop="key" label="来源"></el-table-column>
											<el-table-column prop="value" label="数量"></el-table-column>
											<el-table-column prop="percent" label="占比"></el-table-column>
										</el-table>
										<div class="nodata table-nodata" v-if="meitisDatasLength === 0">
											<div class="nodataImg">
												<div class="textC ">
													<i class="iconfont iconwushuju wushuju-icon"></i>
													<!-- <img src="~@/assets/img/earlyWarning/wsj_07.png" alt="" /> --></div>
												<div class="textC font14 nodataText">暂无数据！</div>
											</div>
										</div>
									</el-row>
								</el-col>
							</el-row>
						</div>
					</div>
				</div>
			</div>
			<div class="layout-special boxBlock" id="specialAll" style="background-color: #ffffff;">
				<div>
					<el-row class="blockTitle">
						<el-col :span="12" class="textColor">专题舆情</el-col>
						<el-col :span="12" class="textR actionCol">
							<!-- <span class="curpointer" @click.stop="domForImage('specialAll', '专题舆情')"><img src="~@/assets/img/monitoring/fenxibaogao/daochu.png" alt="" /></span> -->
							<span class="curpointer" @click.stop="html2canvasFn('specialAll', '专题舆情')">
								<!-- <img src="~@/assets/img/monitoring/fenxibaogao/daochu.png" alt="" /> -->
								<i class="iconfont iconbaocun hovertext" style="font-size: 20px;color:#768594;"></i>
							</span>
						</el-col>
					</el-row>
				</div>
				<div class="line">
					<div class="titleLine titleLineBk"></div>
					<div class="titledot titleLineBk"></div>
					<div class="titledot titledot2 titleLineBk"></div>
					<div class="titledot titledot3 titleLineBk"></div>
				</div>
				<div class="content">
					<div class="meiti" ref="specialAll">
						<div class="meitiRow">
							<el-row type="flex" justify="space-between">
								<el-col :span="2" class="labels">
									<ul class="labelul">
										<li class="textL" v-for="item in speciadList" :key="item.id">
											<span class="dot" :style="{ backgroundColor: item.color }"></span>
											{{ item.minName }}
										</li>
									</ul>
								</el-col>
								<el-col :span="12" class="special-echarts">
									<div id="special" class="special"></div>
									<!-- <div class="nodata" v-if="specialTotal === 0">
										<div class="nodataImg">
											<div class="textC "><img src="~@/assets/img/earlyWarning/wsj_07.png" alt="" /></div>
											<div class="textC font14 nodataText">暂无数据！</div>
										</div>
									</div> -->
								</el-col>
								<el-col :span="10" class="tableCol">
									<el-row class="table-div">
										<el-table
											:data="speciadList2"
											max-height="494"
											style="width: 100%"
											stripe
											border
											:header-cell-style="{ background: '#e7ecf2', color: '#0092f1' }"
										>
											<el-table-column type="index" width="96" label="序号" header-align="center" align="center"></el-table-column>
											<el-table-column prop="name" label="名称"></el-table-column>
											<el-table-column prop="value" label="总数"></el-table-column>
										</el-table>
										<div class="nodata table-nodata" v-if="specialTotal === 0">
											<div class="nodataImg">
												<div class="textC ">
													<i class="iconfont iconwushuju wushuju-icon"></i>
													<!-- <img src="~@/assets/img/earlyWarning/wsj_07.png" alt="" /> --></div>
												<div class="textC font14 nodataText">暂无数据！</div>
											</div>
										</div>
									</el-row>
								</el-col>
							</el-row>
						</div>
					</div>
				</div>
			</div>
			<div class="layout-keywords boxBlock" id="keyChartsAll" style="background-color: #ffffff;">
				<div>
					<el-row class="blockTitle">
						<el-col :span="12" class="textColor ">关键词云</el-col>
						<el-col :span="12" class="textR actionCol">
							<span class="curpointer" @click="domForImage('keyChartsAll', '关键词云')">
								<!-- <img src="~@/assets/img/monitoring/fenxibaogao/daochu.png" alt="" /> -->
								<i class="iconfont iconbaocun hovertext" style="font-size: 20px;color:#768594;"></i>
								</span>
						</el-col>
					</el-row>
				</div>
				<div class="line">
					<div class="titleLine titleLineBk"></div>
					<div class="titledot titleLineBk"></div>
					<div class="titledot titledot2 titleLineBk"></div>
					<div class="titledot titledot3 titleLineBk"></div>
				</div>
				<div class="content">
					<el-row class="contentList">
						<el-col :span="18">
							<div class="keyCharts" id="keyCharts" v-show="titleWordsTotal > 0">
								<word-cloud-chart id="echarts07" class="echarts06" :data="echarts05Data" ref="keyCharts" :sizeRange="[12, 20]" />
							</div>
							<div class="nodata" v-if="titleWordsTotal === 0">
								<div class="nodataImg">
									<div class="textC ">
										<i class="iconfont iconwushuju wushuju-icon"></i>
										<!-- <img src="~@/assets/img/earlyWarning/wsj_07.png" alt="" /> --></div>
									<div class="textC font14 nodataText">暂无数据！</div>
								</div>
							</div>
						</el-col>
						<el-col :span="6" class="textR">
							<el-table :data="eventHighWords" max-height="364" style="width: 100%" stripe border :header-cell-style="{ background: '#e7ecf2', color: '#0092f1' }">
								<el-table-column prop="title" header-align="center" align="center" label="高频词"></el-table-column>
								<el-table-column prop="value" header-align="center" align="center" label="次数"></el-table-column>
							</el-table>
							<!-- titleWordsTotal -->
							<div class="nodata table-nodata" v-if="titleWordsTotal === 0">
								<div class="nodataImg">
									<div class="textC ">
										<i class="iconfont iconwushuju wushuju-icon"></i>
										<!-- <img src="~@/assets/img/earlyWarning/wsj_07.png" alt="" /> --></div>
									<div class="textC font14 nodataText">暂无数据！</div>
								</div>
							</div>
						</el-col>
					</el-row>
				</div>
			</div>
			<div class="layout-two boxBlock" id="layoutTwo">
				<div>
					<el-row class="blockTitle">
						<el-col :span="12" class="textColor">两微人物</el-col>
						<el-col :span="12" class="textR actionCol">
							<span class="curpointer" @click="domForImage('weiboweixinAll', '两微人物')">
								<!-- <img src="~@/assets/img/monitoring/fenxibaogao/daochu.png" alt="" /> -->
								<i class="iconfont iconbaocun hovertext" style="font-size: 20px;color:#768594;"></i>
								</span>
						</el-col>
					</el-row>
				</div>
				<div class="line">
					<div class="titleLine titleLineBk"></div>
					<div class="titledot titleLineBk"></div>
					<div class="titledot titledot2 titleLineBk"></div>
					<div class="titledot titledot3 titleLineBk"></div>
				</div>
				<div class="content">
					<el-row class="contentRow" id="weiboweixinAll" style="background-color: #ffffff;">
						<el-col :span="12">
							<div class="titleB weiboTitle">
								重点微博
								<div class="arrow1"></div>
							</div>
							<div class="tableB">
								<el-table
									v-if="webosTotal > 0"
									:data="webosData"
									max-height="490"
									style="width:100%"
									stripe
									border
									:header-cell-style="{ background: '#e7ecf2', color: '#0092f1' }"
								>
									<el-table-column type="index" width="96" label="序号" header-align="center" align="center"></el-table-column>
									<el-table-column prop="title" header-align="center" align="center" label="名称"></el-table-column>

									<el-table-column prop="value" header-align="center" align="center" label="文章数"></el-table-column>
								</el-table>
								<div class="nodata" v-if="webosTotal === 0">
									<div class="nodataImg">
										<div class="textC ">
											<i class="iconfont iconwushuju wushuju-icon"></i>
											<!-- <img src="~@/assets/img/earlyWarning/wsj_07.png" alt="" /> --></div>
										<div class="textC font14 nodataText">暂无数据！</div>
									</div>
								</div>
							</div>
						</el-col>
						<el-col :span="12">
							<div class="titleB weixinTitle">
								重点微信
								<div class="arrow1"></div>
							</div>
							<div class="tableB">
								<el-table
									v-if="wechatsTotal > 0"
									:data="wechatsData"
									max-height="490"
									style="width:100%"
									stripe
									border
									:header-cell-style="{ background: '#e7ecf2', color: '#0092f1' }"
								>
									<el-table-column type="index" width="96" label="序号" header-align="center" align="center"></el-table-column>
									<el-table-column prop="title" header-align="center" align="center" label="名称"></el-table-column>

									<el-table-column prop="value" header-align="center" align="center" label="文章数"></el-table-column>
								</el-table>
								<!-- wechatsTotal -->
								<div class="nodata" v-if="wechatsTotal === 0">
									<div class="nodataImg">
										<div class="textC ">
											<i class="iconfont iconwushuju wushuju-icon"></i>
											<!-- <img src="~@/assets/img/earlyWarning/wsj_07.png" alt="" /> --></div>
										<div class="textC font14 nodataText">暂无数据！</div>
									</div>
								</div>
							</div>
						</el-col>
					</el-row>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
let moment = require('moment');
import TimeOfPublic from '@/components/TimeOfPublic3.vue';
import FilterStatusTheme from '@/components/FilterStatusTheme.vue';
import WordCloudChart from '@/views/components/home/WordCloudChart.vue';
import statisticsApi from '@/api/statistics';
export default {
	components: {
		TimeOfPublic,
		FilterStatusTheme,
		WordCloudChart
	},
	data() {
		return {
			selDays: 7,
			queryData: {
				startDate: null,
				endDate: null
			},
			curKeyword: {},
			themeList: [],
			checkList: ['all', 'weixin', 'weibo', 'other'],
			myChart1: null,
			yuqingMsg: '', //舆情走势的描述
			yuqingLength: 0,
			weixin: {
				name: '微信',
				type: 'line',
				data: [],
				lineStyle: {
					color: '#82cbf1'
				}
			},
			weibo: {
				name: '微博',
				type: 'line',
				data: [],
				lineStyle: {
					color: '#ff9c4b'
				}
			},
			all: {
				name: '全部',
				type: 'line',
				data: [],
				lineStyle: {
					color: '#269bf2'
				}
			},
			other: {
				name: '其他',
				type: 'line',
				data: [],
				lineStyle: {
					color: '#54e9ea'
				}
			},
			series1: [
				{
					name: '全部',
					type: 'line',
					data: [],
					lineStyle: {
						color: '#269bf2'
					}
				}
			],
			xAxisData1: [],
			myChart2: null,
			activeMigan: '1',
			negative: {
				value: 0,
				name: '敏感',
				itemStyle: {
					color: '#41afff'
				}
			}, //
			positive: {
				value: 0,
				name: '非敏感',
				itemStyle: {
					color: '#ff9351'
				}
			},
			sourceTypeData: [],
			sourceTypeData1: [],
			sourceTypeData2: [],
			sourceTypeData3: [],
			sourceTypeMsg: '', //来源分析 描述
			meitisDatas: [], //来源分析
			meitisDatasLength: 0,
			eventHighWords: [],
			titleWordsTotal: 0,
			wechatsTotal: 0, //重点微信
			wechatsData: [], //重点微信
			webosTotal: 0, //重点微博
			webosData: [], //重点微博
			speciadData: [], //专题舆情
			speciadList: [], //专题舆情
			speciadList2: [], //专题舆情 表格
			myChart3: null,
			echarts05Data: [],
			specialTotal: 0 //专题舆情
		};
	},
	mounted() {
		this.$refs.timeOfPublic.seletedF(7);
		this.getKeywordList(); //专题列表数据
		this.setTreed();
		this.setSource();
		this.setSpecial();
	},
	methods: {
		//发表时间 改变的
		changeTime(obj) {
			this.selDays = obj.days;
			if (obj.val.length > 0) {
				this.queryData.startDate = obj.val[0];
				this.queryData.endDate = obj.val[1];
			}
			// console.log(this.queryData.startDate)
   //          console.log(this.queryData.endDate)
			this.btnSearch();
		},
		changeVal(val) {
			this.curKeyword = val.type;
			this.btnSearch();
		},
		//舆情走势 的选择框
		handleCheckChange() {
			this.series1 = [];

			this.checkList.forEach(item => {
				if (item === 'weixin') {
					this.series1.push(this.weixin);
				} else if (item === 'weibo') {
					this.series1.push(this.weibo);
				} else if (item === 'all') {
					this.series1.push(this.all);
				} else if (item === 'other') {
					this.series1.push(this.other);
				}
			});

			//setTimeout(this.setTreedSetOption, 200);
			setTimeout(() => {
				this.setTreed();
				this.myChart1.resize();
			}, 200);
		},
		setTreed() {
			// 基于准备好的dom，初始化echarts实例
			if (!document.getElementById('treedCharts')) return;
			this.myChart1 = this.$echarts.init(document.getElementById('treedCharts'));
			// 绘制图表
			this.myChart1.clear();
			this.setTreedSetOption();
			window.addEventListener('resize', () => {
				if (this.myChart1) {
					this.myChart1.resize();
				}
			});
		},
		setTreedSetOption() {
			// 绘制图表
			this.myChart1.setOption(
				{
					title: {
						//text: '属性占比'
					},
					tooltip: {
						trigger: 'axis',
						formatter: function(params) {
							var colors = { 全部: '#269bf2', 微博: '#ff9c4b', 微信: '#82cbf1', 其他: '#54e9ea' };
							var result = '';
							var axisValue = '';
							params.forEach(function(item) {
								var dotHtml =
									'<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' +
									colors[item.seriesName] +
									'"></span>';
								result += dotHtml + item.seriesName + ' ' + item.data + '<br>';
								axisValue = item.axisValue;
							});
							return axisValue + '<br>' + result;
						}
					},
					grid: {
						left: '0%',
						right: '15',
						bottom: '0%',
						containLabel: true
					},
					xAxis: {
						type: 'category',
						axisTick: {
							show: false
						},
						axisLine: {
							//y轴
							show: false
						},
						splitLine: {
							lineStyle: {
								type: 'dashed'
							}
						},
						boundaryGap: false,
						data: this.xAxisData1
					},
					yAxis: {
						type: 'value',
						axisTick: {
							show: false
						},
						axisLine: {
							//y轴
							show: false
						},
						splitLine: {
							lineStyle: {
								type: 'dashed'
							}
						}
					},
					series: this.series1
				},
				true
			);
		},
		setSource() {
			// 基于准备好的dom，初始化echarts实例
			if (!document.getElementById('meitiCharts')) return;
			this.myChart3 = this.$echarts.init(document.getElementById('meitiCharts'));
			this.setSourceOption();

			window.addEventListener('resize', () => {
				if (this.myChart3) {
					this.myChart3.resize();
				}
			});
		},
		setSourceOption() {
			let that = this;
			// 绘制图表
			this.myChart3.setOption({
				tooltip: {
					trigger: 'item',
					formatter: '{a} <br/>{b}: {c} ({d}%)'
				},
				grid: {
					left: '0%',
					right: '0%',
					bottom: '0%',
					containLabel: true
				},
				series: [
					{
						name: '敏感度',
						type: 'pie',
						selectedMode: 'single',
						radius: ['15%', '30%'],
						labelLine: {
							show: true
						},
						label: {
							show: true,
							formatter: '{b}{d}%'
						},
						data: [this.negative, this.positive]
					},
					{
						name: '来源分析',
						type: 'pie',
						radius: ['40%', '60%'],
						labelLine: {
							show: true
						},
						label: {
							show: true,
							formatter: function(params) {
								if (that.meitisDatas != null) {
									for (var zbi = 0; zbi < that.meitisDatas.length; zbi++) {
										if (params.name == that.meitisDatas[zbi].key) {
											that.meitisDatas[zbi].percent = params.percent + '%';
										}
									}
								}
								return params.name + '(' + params.percent + '%)';
							}
						},
						data: this.sourceTypeData
					}
				]
			});
		},
		setSpecial() {
			// 基于准备好的dom，初始化echarts实例
			if (!document.getElementById('special')) return;
			this.myChart2 = this.$echarts.init(document.getElementById('special'));
			this.setSpecialOption();
			window.addEventListener('resize', () => {
				if (this.myChart2) {
					this.myChart2.resize();
				}
			});
		},
		setSpecialOption() {
			// 绘制图表
			this.myChart2.setOption(
				{
					tooltip: {
						trigger: 'item',
						formatter: '{a} <br/>{b}: {c} ({d}%)'
					},
					// legend: {
					//     orient: 'vertical',
					//     left: 10,
					//     data: ['直接访问', '邮件营销', '联盟广告', '视频广告', '搜索引擎']
					// },
					grid: {
						left: '0%',
						right: '0%',
						bottom: '0%',
						top: '5%',
						containLabel: true
					},
					series: [
						{
							name: '来源占比',
							type: 'pie',
							radius: ['40%', '80%'],
							// avoidLabelOverlap: false,
							// label: {
							//     show: false,
							//     position: 'center'
							// },
							// emphasis: {
							//     label: {
							//         show: true,
							//         fontSize: '30',
							//         fontWeight: 'bold'
							//     }
							// },
							minAngle: 5,
							avoidLabelOverlap: true,
							labelLine: {
								show: true
							},
							// label: {
							// 	show: true,
							// 	formatter: '{b}{d}%'
							// },
							label: {
								align: 'left',
								normal: {
									formatter(v) {
										let text = v.name + '' + Math.round(v.percent) + '%';
										if (text.length <= 8) {
											return text;
										} else if (text.length > 8 && text.length <= 16) {
											return (text = `${text.slice(0, 8)}\n${text.slice(8)}`);
										} else if (text.length > 16 && text.length <= 24) {
											return (text = `${text.slice(0, 8)}\n${text.slice(8, 16)}\n${text.slice(16)}`);
										} else if (text.length > 24 && text.length <= 30) {
											return (text = `${text.slice(0, 8)}\n${text.slice(8, 16)}\n${text.slice(16, 24)}\n${text.slice(24)}`);
										} else if (text.length > 30) {
											return (text = `${text.slice(0, 8)}\n${text.slice(8, 16)}\n${text.slice(16, 24)}\n${text.slice(24, 30)}\n${text.slice(30)}`);
										}
									},
									textStyle: {
										fontSize: 14
									}
								}
							},
							data: this.speciadData
						}
					]
				},
				true
			);
		},
		toggleMigan(numstr) {
			this.activeMigan = numstr;
			if (numstr === '1') {
				this.getAnalyzeField('sourceType', null, null);
			} else if (numstr === '2') {
				this.getAnalyzeField('sourceType', null, 1);
			} else if (numstr === '3') {
				this.getAnalyzeField('sourceType', null, 0);
			}
		},
		btnSearch() {
			let _this = this;
			_this.getYqTrendPicList(); //舆情走势图表数据接口
			_this.getYqTrendWordList(); //舆情走势文字数据接口
			_this.getAnalyzeField('sourceType', null, null, null); //统计分析(来源分析
			_this.getAnalyzeField('author', 9, 0, 11); //统计分析---两微人物-微信
			_this.getAnalyzeField('author', 4, 0, 11); //统计分析---两微人物-微博
			_this.getTopicRankingList(); //专题舆情
			_this.getWordCloudList(); //词云
		},
		async getKeywordList() {
			//专题列表数据
			let _this = this;
			let data = { warnStatus: 0 };
			_this.themeList = [];
			let quanbu = {
				id: '',
				keyword: '全部'
			};

			let res = await statisticsApi.getKeywordList(data);
			if (res.returnCode == '1001') {
				_this.themeList = res.returnData;
				_this.themeList.unshift(quanbu);
			}
		},
		NewDateStr:function(str){
			if(!str){
				return 0;
			}
			let arr=str.split(" ");
			let d=arr[0].split("-");
			let t=arr[1].split(":");
			let date = new Date();
			date.setUTCFullYear(d[0], d[1] - 1, d[2]-1);
			date.setUTCHours(t[0], t[1], t[2], 0);
			return date;
		},
        NewDate:function(str){
            return str.toString().substr(0,10);
        },
		async getYqTrendPicList() {
			//舆情走势图表数据接口
			let _this = this;
			let data = {
				index: _this.curKeyword.id,
				property: '',
				deleted: 0,
				startDate: _this.queryData.startDate,
				endDate: _this.queryData.endDate,
				pageNo: 0,
				pageSize: 100
			};
			let res = await statisticsApi.getYqTrendPicList(data);

			if (res.returnCode !== '1001') return false;
			this.yuqingLength = res.returnData.countLine.length;
			let counts = res.returnData;
			this.xAxisData1 = [];
			let winxinTotal = 0; //微信
			let winboTotal = 0; //微博
			let otherTotal = 0; //其它
			let allTotal = 0; //全部
			let countlength = res.returnData.countLine.length; //总长度
			if (res.returnData.countLine.length > 0) {
				this.all.data = [];
				res.returnData.countLine.forEach(item => {
					this.all.data.push(Number(item.value));

					this.xAxisData1.push(moment(this.NewDate(item.title)).format('MM.DD'));
				});
			}
			if (res.returnData.otherLine.length > 0) {
				this.other.data = [];
				res.returnData.otherLine.forEach(item => {
					this.other.data.push(Number(item.value));
					otherTotal += Number(item.value);
				});
			}
			if (res.returnData.weiXinLine.length > 0) {
				this.weixin.data = [];
				res.returnData.weiXinLine.forEach(item => {
					this.weixin.data.push(Number(item.value));
					winxinTotal += Number(item.value);
				});
			}
			if (res.returnData.weiBoLine.length > 0) {
				this.weibo.data = [];
				res.returnData.weiBoLine.forEach(item => {
					this.weibo.data.push(Number(item.value));
					winboTotal += Number(item.value);
				});
			}

			//this.NewDateStr(this.queryData.endDate)
			const keywordTime = moment(this.NewDate(this.queryData.startDate)).format('YYYY-MM-DD') + '~' + moment(this.NewDate(this.queryData.endDate)).format('YYYY-MM-DD');
			allTotal = otherTotal + winxinTotal + winboTotal;
			this.yuqingMsg = `${keywordTime}舆情监测系统共监测到舆情信息<span class="spanColor">${allTotal}</span>条，其中微信<span class="spanColor">${winxinTotal}</span>条，微博<span class="spanColor">${winboTotal}</span>条，其它<span class="spanColor">${otherTotal}</span>条。`;
			this.handleCheckChange();
		},
		async getYqTrendWordList() {
			//舆情走势文字数据接口
			let _this = this;
			let data = {
				index: _this.curKeyword.id,
				deleted: 0,
				interval: '1d',
				startDate: _this.queryData.startDate,
				endDate: _this.queryData.endDate,
				pageNo: 1,
				pageSize: 100
			};
			let res = await statisticsApi.getYqTrendWordList(data);

			//returnCode: "1001"
			//returnData:{} endDate startDate negative[ {title: "2020-06-11 00:00:00", value: 0}] positive[]
			if (res.returnCode !== '1001') return false;

			let totalCount = 0,
				negativeCount = 0,
				positiveCount = 0;

			res.returnData.negative.forEach((item, index) => {
				negativeCount = negativeCount + item.value;
			});

			res.returnData.positive.forEach((item, index) => {
				positiveCount = positiveCount + item.value;
			});

			totalCount = negativeCount + positiveCount;

			this.negative.value = negativeCount;
			this.positive.value = positiveCount;
			this.setSourceOption();
		},
		async getAnalyzeField(analyzeField, sourceType, property, pageSize) {
			// 统计分析(来源分析、两微人物)
			let _this = this;
			let data = {
				index: _this.curKeyword.id,
				analyzeField: analyzeField,
				deleted: 0,
				startDate: _this.queryData.startDate,
				endDate: _this.queryData.endDate,
				pageNo: 1,
				pageSize: pageSize || 100,
				sourceType: sourceType,
				property: property // 敏感1 非敏感 0
			};
			let res = await statisticsApi.getAnalyzeList(data);

			if (res.returnCode !== '1001') return false;
			if (analyzeField === 'sourceType') {
				res.returnData = res.returnData.filter((item, index) => {
					return item.value > 0;
				});
				res.returnData.sort((a, b) => {
					return Number(b.value) - Number(a.value);
				});
				this.setSourceType(res, property);
			} else if (analyzeField === 'author' && sourceType === 9) {
				//分析报告---两微人物-微信
				this.wechatsTotal = res.returnData.total;
				this.wechatsData = [];
				if (res.returnData.total > 0) {
					res.returnData.data = res.returnData.data.filter((item, index) => {
						return item.value > 0;
					});
					res.returnData.data.sort((a, b) => {
						return Number(b.value) - Number(a.value);
					});
					this.wechatsData = res.returnData.data;
				}
			} else if (analyzeField === 'author' && sourceType === 4) {
				//分析报告---两微人物-微博
				this.webosTotal = res.returnData.total;
				this.webosData = [];
				if (res.returnData.total > 0) {
					res.returnData.data = res.returnData.data.filter((item, index) => {
						return item.value > 0;
					});
					res.returnData.data.sort((a, b) => {
						return Number(b.value) - Number(a.value);
					});
					this.webosData = res.returnData.data;
				}
			}
		},
		async getTopicRankingList() {
			//专题舆情
			let _this = this;
			let data = {
				index: _this.curKeyword.id,
				startDate: _this.queryData.startDate,
				endDate: _this.queryData.endDate,
				pageNo: 1,
				pageSize: 100
			};
			let res = await statisticsApi.getTopicRankingList(data);
			if (res.returnCode !== '1001') return false;

			let datas = JSON.parse(JSON.stringify(res.returnData.data));
			datas = datas.filter((item, index) => {
				return item.value > 0;
			});

			datas.sort((a, b) => {
				return Number(b.value) - Number(a.value);
			});

			datas = datas.slice(0, 10);
			
			let colorList = [
				'#c981dd',
				'#33dfd8',
				'#98ffe3',
				'#ebc4fd',
				'#fa7ca3',
				'#9bea7d',
				'#ff806b',
				'#fff006',
				'#ffe3ee',
				'#5aaaff',
				'#47d1de',
				'#88e5c9',
				'#ffd6bf',
				'#ffe168',
				'#ff806b',
				'#adb1f2'
			];
			this.speciadData = [];
			this.speciadList = [];
			this.speciadList2 = [];
			this.specialTotal = datas.length;
			
			if (datas.length > 0) {
				var dataDatas = datas;
				dataDatas.forEach((item, index) => {
					
					//限制显示8个专题
					if (index < 8) {
						this.speciadData.push({
							value: item.value,
							name: item.name,
							itemStyle: {
								color: colorList[index]
							}
						});
						let minName = item.name.length > 5 ? `${item.name.substring(0,5)}...` : item.name;

						this.speciadList.push({
							id: item.id,
							value: item.value,
							name: item.name,
							color: colorList[index],
							minName: minName
						});

						this.speciadList2 = this.speciadList.filter((item, index) => {
							return index < 10;
						});
					}
				});
			} else {
				this.speciadData.push({
					value: 0,
					name: '无数据',
					itemStyle: {
						color: colorList[1]
					}
				});
			}
            if(this.myChart2){
				this.setSpecialOption();
			}
			
			// returnCode: "1001"
			// returnData:
			// data: []
			// total: 0
			// totalPage: 0
			// data: Array(1)
			// 0: {name: "新型肺炎", id: 13971, title: "13971", value: 3, dotindex: 1}
		},
		async getWordCloudList() {
			//关键词云
			let _this = this;
			let data = {
				index: _this.curKeyword.id,
				startDate: _this.queryData.startDate,
				endDate: _this.queryData.endDate,
				pageNo: 1,
				pageSize: 30
			};
			let res = await statisticsApi.getWordCloudList(data);
			if (res.returnCode !== '1001') return false;

			this.echarts05Data = [];
			this.eventHighWords = [];
			this.titleWordsTotal = res.returnData.titleWords.length;

			if (res.returnData.titleWords.length > 0) {
				res.returnData.titleWords.forEach((item, index) => {
					this.echarts05Data.push({
						name: item.title,
						value: item.value
					});
					if (index < 8) {
						this.eventHighWords.push(item);
					}
				});

				// this.$nextTick(()=>{
				// 	setTimeout(()=>{

				// 		 if(this.$refs.keyCharts){
				// 			 this.$refs.keyCharts.initChart()
				// 		 }
				// 	}, 200);
				// })
			}
			this.$nextTick(() => {
				setTimeout(() => {
					if (this.$refs.keyCharts) {
						this.$refs.keyCharts.initChart();
						this.$refs.keyCharts.resizeW();
					}
				}, 200);
			});
		},
		//来源分析 的数据绑定
		setSourceType(res, property) {
			let that = this;
			this.meitisDatas = [];
			this.sourceTypeData = [];

			res.returnData.forEach(item => {
				this.meitisDatas.push({ id: item.id, key: item.key, value: item.value, color: item.color, percent: '1%' });
				this.sourceTypeData.push({
					value: item.value,
					name: item.key,
					itemStyle: {
						color: item.color
					}
				});
			});
			this.meitisDatasLength = this.meitisDatas.length;
			this.setSourceOption();
			let meitisDatasSort = JSON.parse(JSON.stringify(this.meitisDatas));
			meitisDatasSort.sort((a, b) => {
				return Number(b.value) - Number(a.value);
			});
			let sourceTypeMsgs = [];
			meitisDatasSort.forEach(item => {
				sourceTypeMsgs.push(`，${item.key}舆情信息${item.value}条,占比${item.percent}`);
			});

			setTimeout(() => {
				that.sourceTypeMsg = `根据下图可知${sourceTypeMsgs.join('')}` + `，其中敏感舆情${that.negative.value}条，非敏感舆情${that.positive.value}条。`;
			}, 300);

			if (property == 1) {
				this.sourceTypeData2 = meitisDatasSort;
			} else if (property == 0) {
				this.sourceTypeData3 = meitisDatasSort;
			} else {
				this.sourceTypeData1 = meitisDatasSort;
			}
		},
		async exportStatistics() {
			let _this = this;

			this.getAnalyzeField('sourceType', null, null);
			this.getAnalyzeField('sourceType', null, 1);
			this.getAnalyzeField('sourceType', null, 0);

			let yuQingZouShiImg2 = null,
				activePersonsImg2 = null,
				activeMediaImg2 = null,
				hotWordsImg2 = null,
				yuQingTongJiImg2,
				mediaTypeImg2 = null;
			const yuQingZouShiImg = await _this.domtoimage.toBlob(document.getElementById('treedCharts'));

			if (yuQingZouShiImg != null) {
				_this.blobToDataURL(yuQingZouShiImg, function(res) {
					yuQingZouShiImg2 = res;
				});
			}

			const mediaTypeImg = await _this.domtoimage.toBlob(document.getElementById('meitiCharts'));
			if (mediaTypeImg != null) {
				_this.blobToDataURL(mediaTypeImg, async function(res) {
					mediaTypeImg2 = await res;
				});
			}

			const yuQingTongJiImg = await _this.domtoimage.toBlob(document.getElementById('special'));
			if (yuQingTongJiImg != null) {
				_this.blobToDataURL(yuQingTongJiImg, async function(res) {
					yuQingTongJiImg2 = await res;
				});
			}

			const hotWordsImg = await _this.domtoimage.toBlob(document.getElementById('echarts07'));

			if (hotWordsImg != null) {
				_this.blobToDataURL(hotWordsImg, async function(res) {
					hotWordsImg2 = await res;
				});
			}

			let sourceTypeData1 = this.sourceTypeData1,
				sourceTypeData2 = this.sourceTypeData2,
				sourceTypeData3 = this.sourceTypeData3;

			for (var i = 0; i < sourceTypeData1.length; i++) {
				for (var j = 0; j < sourceTypeData2.length; j++) {
					if (sourceTypeData1[i].key == sourceTypeData2[j].key) {
						sourceTypeData1[i].percent2 = sourceTypeData2[j].percent;
						sourceTypeData1[i].value2 = sourceTypeData2[j].value;
						break;
					}
				}
				for (var j = 0; j < sourceTypeData3.length; j++) {
					if (sourceTypeData1[i].key == sourceTypeData3[j].key) {
						sourceTypeData1[i].percent3 = sourceTypeData3[j].percent;
						sourceTypeData1[i].value3 = sourceTypeData3[j].value;
						break;
					}
				}
			}

			if (hotWordsImg2) return false;
			const keywordTime = moment(this.NewDate(this.queryData.startDate)).format('YYYY-MM-DD') + '~' + moment(this.NewDate(this.queryData.endDate)).format('YYYY-MM-DD');

			setTimeout(() => {
				const datas = {
					speciadList: _this.speciadList2,
					weiboList: _this.webosData,
					weixinList: _this.wechatsData,
					wordcloudList: _this.echarts05Data,
					wordcloudList2: _this.echarts05Data.slice(0, 3),
					keywordTime: keywordTime,
					keywordInfo: _this.yuqingMsg,
					yuQingZouShiImg: yuQingZouShiImg2,
					hotWordsImg: hotWordsImg2,
					yuQingTongJiImg: yuQingTongJiImg2,
					mediaTypeImg: mediaTypeImg2,
					mediaTypeList: sourceTypeData1
				};

				this.exportPost(datas);
			}, 200);
		},
		blobToDataURL(blob, callback) {
			let a = new FileReader();
			a.onload = function(e) {
				callback(e.target.result);
			};
			a.readAsDataURL(blob);
		},
		async exportPost(datas) {
			let rst = await statisticsApi.exportStatistics(datas);

			let url = '/jiance/file/' + rst.returnData.url;
			window.open(url, '_blank');
		},
		domForImage(domId, fileName) {
			if (fileName.indexOf('.png') != -1) {
				fileName += '.png';
			}
			let keyword = typeof this.curKeyword.keyword;
			keyword = keyword == null || keyword == undefined || keyword == 'undefined' ? '全部' : this.curKeyword.keyword;
			fileName = keyword + '-' + fileName;
			this.domtoimage.toBlob(document.getElementById(domId),{ quality: 0.95 }).then(function(blob) {
				window.saveAs(blob, fileName);
			});




			/*var node = document.getElementById(domId,);

            this.domtoimage.toPng(node)
                .then(function (dataUrl) {
                    var img = new Image();
                    img.src = dataUrl;
                    img.bgColor='red'

                    document.body.appendChild(img);
                    var a=document.createElement('a')
					a.setAttribute("style","display:none")
                    a.setAttribute('href',dataUrl)
                    a.setAttribute('download',"1.png")
                    a.click()

                })
                .catch(function (error) {

                })*/
		},
		html2canvasFn(domRef, fileName) {
			this.$html2canvas(this.$refs[domRef]).then(canvas => {
				// 转成图片，生成图片地址
				this.imgUrl = canvas.toDataURL('image/png'); //可将 canvas 转为 base64 格式

				if (window.navigator.msSaveOrOpenBlob) {
					let bstr = atob(this.imgUrl.split(',')[1]);
					let n = bstr.length;
					let u8arr = new Uint8Array(n);
					while (n--) {
						u8arr[n] = bstr.charCodeAt(n);
					}
					let blob = new Blob([u8arr]);
					window.navigator.msSaveOrOpenBlob(blob, fileName + '.png');
				} else {
					let blob = this.base64ToBlob(this.imgUrl); //new Blob([content]);
					let aLink = document.createElement('a');
					let evt = document.createEvent('HTMLEvents');
					evt.initEvent('click', true, true); //initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
					aLink.download = fileName + '.png';
					aLink.href = URL.createObjectURL(blob);

					// aLink.dispatchEvent(evt);
					aLink.click();
				}
			});
		},
		//base64转blob
		base64ToBlob: function(code) {
			let parts = code.split(';base64,');
			let contentType = parts[0].split(':')[1];
			let raw = window.atob(parts[1]);
			let rawLength = raw.length;

			let uInt8Array = new Uint8Array(rawLength);

			for (let i = 0; i < rawLength; ++i) {
				uInt8Array[i] = raw.charCodeAt(i);
			}
			return new Blob([uInt8Array], { type: contentType });
		}
	}
};
</script>

<style lang="less">
@import '~@/assets/css/page/statistics/statistics.less';
</style>
